module.exports = __webpack_public_path__ + "img/upload.7421a526.svg";